import { CRUD_LABEL_PROPS } from "./CrudLabelProps.js";

export const CRUD_INPUT_PROPS = {
	id: {
		required: true,
		type: String,
		default: ""
	},
	name: {
		required: true,
		type: String,
		default: ""
	},
	type: {
		required: true,
		type: String,
		default: "text"
	},
	value: {
		required: false,
		type: [String, Number]
	},
	placeholder: {
		required: true,
		type: String,
		default: ""
	},
	validationRules: {
		required: false,
		type: Object,
		default: null
	},
	registerListener: {
		required: false,
		type: Boolean,
		default: true
	},
	isManagementListener: {
		required: false,
		type: Boolean,
		default: false
	},

	...CRUD_LABEL_PROPS
}
